import React, { memo } from "react";
import { Clock, Sparkles, Check } from "lucide-react";
import PredictButton from "../../../../components/dashboards/components/shared/PredictButton";
import XPicksButton from "../../../../components/dashboards/components/shared/XPicksButton";
import PredictionBox from "../../../../components/dashboards/components/shared/PredictionBox";

const MMAMobileFightCard = memo(({
  fight,
  isSelected,
  isFrozen = false,
  onToggleSelection,
  prediction,
  onViewPrediction
}) => {
  const first = fight?.fighters?.first || fight?.fighters?.home || fight?.fighters?.red || fight?.fighters?.[0];
  const second = fight?.fighters?.second || fight?.fighters?.away || fight?.fighters?.blue || fight?.fighters?.[1];
  const fightDate = (fight?.date || '').slice(0, 10);

  const status = fight?.status?.long || fight?.status || '';
  const isLive = ['Live', 'LIVE', 'ongoing'].includes(status);
  const isFinished = ['Finished', 'FT', 'final'].includes(status);
  const isUpcoming = !isLive && !isFinished;

  return (
    <div className={`rounded-lg p-4 transition-all duration-200 border ${
      isSelected ? 'border-emerald-500/50 bg-emerald-500/10' : 'border-white/10 bg-white/[0.02]'
    }`}>
      <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-gray-300 mb-2">
        {fight?.league?.name || fight?.event || 'Event'}
      </div>

      <div className="space-y-2">
        {[first, second].map((fighter, idx) => (
          <div key={idx} className="flex items-center gap-3">
            {fighter?.logo && (
              <img
                src={fighter.logo}
                alt={fighter.name}
                className="w-8 h-8 rounded-full object-cover border border-white/10"
                loading="lazy"
              />
            )}
            <span className="text-sm text-white font-semibold truncate">{fighter?.name || 'Fighter'}</span>
          </div>
        ))}
      </div>

      <div className="mt-3 flex flex-col items-center gap-1 text-xs text-white/60">
        <div className="flex items-center gap-2">
          <Clock size={12} />
          <span>{fightDate || 'TBD'}</span>
        </div>
        {fight?.time && <span>{fight.time} {fight?.timezone || 'UTC'}</span>}
      </div>

      {/* Prediction Result (if available) */}
      {prediction && (
        <div className="mt-3">
          <PredictionBox
            prediction={prediction}
            onAnalyze={() => onViewPrediction?.(fight)}
            variant="mobile"
          />
        </div>
      )}

      {/* Action Buttons */}
      {(isUpcoming || isLive) && (
        <div className="mt-3 grid grid-cols-2 gap-2">
          {/* xPicks Button */}
          <div className="col-span-1">
            <XPicksButton
              gameData={{
                homeTeam: first?.name,
                awayTeam: second?.name,
                date: fightDate,
                time: fight?.time || 'TBD',
                gameId: fight?.id
              }}
              sport="mma"
              label="XPICKS"
            />
          </div>

          {/* Prediction Button */}
          {onToggleSelection && (
            <div className="col-span-1">
              <PredictButton
                label={isFrozen ? "COOLDOWN" : isSelected ? "SELECTED" : isLive ? "PREDICT LIVE" : "PREDICT"}
                icon={isFrozen ? Clock : isSelected ? Check : Sparkles}
                isSelected={isSelected}
                isLive={isLive}
                isFrozen={isFrozen}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isFrozen) {
                    onToggleSelection(fight);
                  }
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
});

MMAMobileFightCard.displayName = 'MMAMobileFightCard';

export default MMAMobileFightCard;
